import React from 'react';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import enCommon from '../locales/en/common.json';
import enLayout from '../locales/en/layout.json';
import enMonitoring from '../locales/en/monitoring.json';
import enCrm from '../locales/en/crm.json';
import enChats from '../locales/en/chats.json';
import enAssistant from '../locales/en/assistant.json';
import enOutbound from '../locales/en/outbound.json';
import enCarstock from '../locales/en/carstock.json';
import itCommon from '../locales/it/common.json';
import itLayout from '../locales/it/layout.json';
import itMonitoring from '../locales/it/monitoring.json';
import itCrm from '../locales/it/crm.json';
import itChats from '../locales/it/chats.json';
import itAssistant from '../locales/it/assistant.json';
import itOutbound from '../locales/it/outbound.json';
import itCarstock from '../locales/it/carstock.json';
import esCommon from '../locales/es/common.json';
import esLayout from '../locales/es/layout.json';
import esMonitoring from '../locales/es/monitoring.json';
import esCrm from '../locales/es/crm.json';
import esChats from '../locales/es/chats.json';
import esAssistant from '../locales/es/assistant.json';
import esOutbound from '../locales/es/outbound.json';
import esCarstock from '../locales/es/carstock.json';

export const SUPPORTED_LANGUAGES = ['it', 'en', 'es'];
export const SWITCHABLE_LANGUAGES = ['en', 'es'];
export const FALLBACK_LANGUAGE = 'it';

const resources = {
  en: {
    common: enCommon,
    layout: enLayout,
    monitoring: enMonitoring,
    crm: enCrm,
    chats: enChats,
    assistant: enAssistant,
    outbound: enOutbound,
    carstock: enCarstock,
  },
  it: {
    common: itCommon,
    layout: itLayout,
    monitoring: itMonitoring,
    crm: itCrm,
    chats: itChats,
    assistant: itAssistant,
    outbound: itOutbound,
    carstock: itCarstock,
  },
  es: {
    common: esCommon,
    layout: esLayout,
    monitoring: esMonitoring,
    crm: esCrm,
    chats: esChats,
    assistant: esAssistant,
    outbound: esOutbound,
    carstock: esCarstock,
  },
};

const detectInitialLanguage = () => {
  const stored = localStorage.getItem('lang');
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  return FALLBACK_LANGUAGE;
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: detectInitialLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ['common', 'layout', 'monitoring', 'crm', 'chats', 'assistant', 'outbound', 'carstock'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    load: 'languageOnly',
  });
}

const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (language, callback) => {
  if (SUPPORTED_LANGUAGES.includes(language)) {
    localStorage.setItem('lang', language);
  }
  return originalChangeLanguage(language, callback);
};

// Compatibility wrapper to avoid changing the app bootstrap now.
export const I18nProvider = ({ children }) => <>{children}</>;

export { useTranslation };
export default i18n;
